<div class="inner-header">
    <h4>Costing Items</h4>
    <div class="panel panel-white select-all" [class.selected]="allSelected">
        <input legacy-css type="checkbox" id="select-all" [checked]="allSelected" (change)="selectAll()" />
        <label for="select-all">
            <strong>Select All</strong>
        </label>
    </div>
</div>
<div class="inner-body" *ngIf="recipient?.quoteRequestRecipientGroups?.length">
    <div class="cost-item-headings">
        <span class="item-heading">Description</span>
        <span class="item-heading col-2 align-center">Item Code</span>
        <span class="item-heading"><!-- Material --></span>
        <span class="item-heading">Qty</span>
        <span class="item-heading">UOM</span>
        <span class="item-heading col-3 align-center">{{ taxProfile.TaxRatesShortCode }}</span>
        <span class="item-heading tax-rates-heading" *ngIf="(recipient?.quoteRequest?.calculationMethod || 0) > 0"></span>
        <span class="item-heading tax-heading"></span>
        <span class="item-heading total">Total</span>
    </div>
    <ng-container *ngFor="let group of recipient.quoteRequestRecipientGroups">
        <div class="panel panel-white" [class.selected]="groupSelectedDict[group.iD_QuoteRequestRecipientGroup]">
            <input
                legacy-css
                type="checkbox"
                id="category-{{ group.iD_QuoteRequestRecipientGroup }}"
                [checked]="groupSelectedDict[group.iD_QuoteRequestRecipientGroup]"
                (change)="selectGroup(group.iD_QuoteRequestRecipientGroup)" />
            <label for="category-{{ group.iD_QuoteRequestRecipientGroup }}">
                <strong>{{ group.description }}</strong>
            </label>
        </div>

        <ng-container *ngFor="let item of itemsByGroup[group.iD_QuoteRequestRecipientGroup]">
            <div class="panel panel-white recipient-item" [class.selected]="item.isSelected">
                <span>
                    <input
                        legacy-css
                        type="checkbox"
                        id="item-{{ item.iD_QuoteRequestRecipientItem }}"
                        [checked]="item.isSelected"
                        (change)="selectItem(item)" />
                    <label for="item-{{ item.iD_QuoteRequestRecipientItem }}">{{ item.description }}</label>
                </span>
                <span>{{ item.itemCode }}</span>
                <span class="material-container">{{ costItemDict[item.costItemType] }}</span>
                <span>{{ item.quantity }}</span>
                <span>{{ item.uOM }}</span>
                <div>
                    <span class="right-aligned">{{ item.tax | bxCurrency }}</span>
                </div>
                <div class="tax-rates-col">
                    <tax-rate-selector
                        *ngIf="item.calculationMethod > 0 && (!item.isRecipe || item.calculationMethod < 2)"
                        [editable]="true"
                        [taxType]="1"
                        [costItemType]="item.costItemType"
                        [selectedTaxCodes]="item.taxRates"
                        [taxRatesParent]="taxProfile"
                        (selectedChanged)="updateTaxRates($event, item)"
                        (taxValuesReset)="updateTaxStatus(item)"
                        [placement]="'left'">
                    </tax-rate-selector>
                </div>
                <span class="tax-col">
                    <ng-select
                        *ngIf="!item.isRecipe || item.calculationMethod < 2"
                        class="light"
                        name="taxStatus"
                        [items]="taxStatusOptions"
                        placeholder="Select from one of the below"
                        [clearable]="false"
                        [searchable]="false"
                        appendTo="body"
                        bindLabel="display"
                        bindValue="name"
                        [(ngModel)]="item.taxStatus"
                        (change)="updateTaxStatus(item)">
                    </ng-select>
                </span>
                <input
                    legacy-css
                    *ngIf="!item.isRecipe; else readOnlyTotals"
                    type="text"
                    class="total form-control-v2 full-width text-right"
                    appCurrency
                    [ngModel]="item.total"
                    (ngModelChange)="inputUpdated(item, itemTotal.value)"
                    #itemTotal
                    [min]="0" />

                <ng-template #readOnlyTotals>
                    <div class="total">
                        <span class="right-aligned">{{ item.total | bxCurrency }}</span>
                    </div>
                </ng-template>
                <ng-container *ngIf="item.isAddedByRecipient; else Requested">
                    <span class="tag additional">Additional</span>
                </ng-container>
                <ng-template #Requested>
                    <span class="tag requested">Requested</span>
                </ng-template>
            </div>

            <!-- recipe items -->
            <ng-container *ngFor="let recipeItem of recipeItemsByItem[item.iD_QuoteRequestRecipientItem]">
                <div class="panel panel-white recipient-item recipe-item" [class.selected]="recipeItem.isSelected">
                    <span>
                        <input
                            legacy-css
                            [disabled]="item.isAddedByRecipient === recipeItem.isAddedByRecipient"
                            type="checkbox"
                            id="item-{{ recipeItem.iD_QuoteRequestRecipientRecipeItem }}"
                            [checked]="recipeItem.isSelected"
                            (change)="selectRecipeItem(recipeItem, item)" />
                        <label for="item-{{ recipeItem.iD_QuoteRequestRecipientRecipeItem }}">{{ recipeItem.description }}</label>
                    </span>
                    <span>{{ recipeItem.itemCode }}</span>
                    <span class="material-container">{{ costItemDict[recipeItem.costItemType] }}</span>
                    <span>{{ recipeItem.uOMUnits }}</span>
                    <span>{{ recipeItem.uOM }}</span>
                    <div>
                        <span class="right-aligned">{{ recipeItem.tax | bxCurrency }}</span>
                    </div>
                    <div class="tax-rates-col">
                        <tax-rate-selector
                            *ngIf="item.calculationMethod >= 2"
                            [editable]="true"
                            [taxType]="1"
                            [costItemType]="recipeItem.costItemType"
                            [selectedTaxCodes]="recipeItem.taxRates"
                            [taxRatesParent]="taxProfile"
                            (selectedChanged)="updateRecipeItemTaxRates($event, recipeItem, item)"
                            (taxValuesReset)="updateRecipeItemTaxStatus(recipeItem, item)"
                            [placement]="'left'">
                        </tax-rate-selector>
                    </div>
                    <span class="tax-col">
                        <ng-select
                            *ngIf="item.calculationMethod >= 2; else simpleTaxStatus"
                            class="light"
                            name="taxStatus"
                            [items]="taxStatusOptions"
                            placeholder="Select from one of the below"
                            [clearable]="false"
                            [searchable]="false"
                            appendTo="body"
                            bindLabel="display"
                            bindValue="name"
                            [(ngModel)]="recipeItem.taxStatus"
                            (change)="updateRecipeItemTaxStatus(recipeItem, item)">
                        </ng-select>
                        <ng-template #simpleTaxStatus>
                            {{
                                recipeItem.taxStatus === rfqItemTaxStatus[rfqItemTaxStatus.TAXINCLUDED]
                                    ? 'Inc'
                                    : recipeItem.taxStatus === rfqItemTaxStatus[rfqItemTaxStatus.TAXEXCLUDED]
                                      ? 'Ex'
                                      : 'No tax'
                            }}
                        </ng-template>
                    </span>
                    <input
                        legacy-css
                        type="text"
                        class="total form-control-v2 full-width text-right"
                        appCurrency
                        #recipeItemTotal
                        [ngModel]="recipeItem.total"
                        (ngModelChange)="inputUpdated(item, recipeItemTotal.value, recipeItem)"
                        [min]="0" />
                    <ng-container *ngIf="recipeItem.isAddedByRecipient; else Requested">
                        <span class="tag additional">Additional</span>
                    </ng-container>
                    <ng-template #Requested>
                        <span class="tag requested">Requested</span>
                    </ng-template>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</div>
<div class="inner-footer">
    <div class="footer-details">
        <span class="detail-title">Sub Total</span>
        <span class="detail-title">{{ taxProfile.TaxRatesShortCode }}</span>
        <span class="detail-title">Total</span>
        <span class="detail-item">{{ total | bxCurrency }}</span>
        <span class="detail-item">{{ tax | bxCurrency }}</span>
        <span class="detail-item">{{ totalIncTax | bxCurrency }}</span>
    </div>
</div>
